

















import { Component, Prop, Vue } from 'vue-property-decorator'
import debug from '@/helpers/debug'
import { DefaultServerResponse } from '@/components/ui/TechTaskCard.vue'
import js2excel from 'js2excel'
import request from '@/helpers/requests'


interface TransactionRow {
    pulsemAccountId: number;
    name: string|null;
    positive: number|null;
    neutral: number|null;
    negative: number|null;
    pulsemIndex: number|null;
    brandAmbassador: number|null;
    promoter: number|null;
    detractor: number|null;
}


interface TransactionRows {
    rows: TransactionRow[];
}


interface TransactionData extends DefaultServerResponse {
    data: TransactionRows;
}


@Component
export default class TransactionTable extends Vue {
    @Prop() accountId!: number
    @Prop() beginDate!: string
    @Prop() fromDate!: string
    @Prop() toDate!: string
    transactionReport: TransactionRow[] = []
    search = ''
    loading = false
    transactionHeaders = [
        { text: 'Location Name', align: 'left', value: 'name' },
        { text: 'Pulsem Account ID', value: 'pulsemAccountId' },
        { text: 'Positive', value: 'positive' },
        { text: 'Neutral', value: 'neutral' },
        { text: 'Negative', value: 'negative' },
        { text: 'Pulsem Index', value: 'pulsemIndex' },
        { text: 'Brand Ambassador', value: 'brandAmbassador' },
        { text: 'Promoter', value: 'promoter' },
        { text: 'Detractor', value: 'detractor' }
    ]

    /**
     * This functions retrieves the pertinent data for the report from the endpoint using accountId, fromDate, and
     * toDate.
     * @returns { TransactionData }
     */
    async getTransactionData(): Promise<TransactionData> {
        return await request.post('/support/franchise/transaction-report', {
            accountId: this.accountId,
            beginDate: this.beginDate,
            fromDate: this.fromDate,
            toDate: this.toDate
        }) as TransactionData
    }

    async compileData() {
        this.loading = true
        const data = await this.getTransactionData()
        this.transactionReport = data.data.rows
        this.loading = false
    }

    /**
     * This function is responsible for the exporting of the data from the report to an excel sheet.
     * NOTE: This arranges the columns in a strange way. It sorts columns in alphabetical order.
     * These file names may also not exceed 31 characters.
     */
    exportToExcel() {
        const reportName = 'transaction_report'
        const data = this.transactionReport
        const date = new Date().toISOString().slice(0, 10)
        const name = reportName.concat('_' + date)
        try {
            js2excel.json2excel({
                data,
                name,
                formateDate: 'yyyy/mm/dd'
            })
        } catch(e) {
            debug.error('Excel export error')
        }
    }
}
